




















import Vue from "vue";

import { ecrCodeStatusEnumLabel, EcrCodeStatusEnum } from "@/model/data/ecr/EcrCodeStatusEnum";

export default Vue.extend({
    data() {
        return {
            loading: false,
            selectedItems: [],
        };
    },
    computed: {
        availableEcrCodeStatus() {
            var res = [];
            Object.keys(EcrCodeStatusEnum)
                .filter((k) => typeof EcrCodeStatusEnum[k as any] === "number")
                .forEach((k) => {
                    if (EcrCodeStatusEnum[k] >= 0) res.push({ label: this.$t(ecrCodeStatusEnumLabel(EcrCodeStatusEnum[k])), value: EcrCodeStatusEnum[k as any] });
                });
            return res;
        },
    },
    watch: {
        selectedItems() {
            this.$emit("input", this.selectedItems);
        },
    },
});
